import React, { useState, useEffect } from 'react';

const LoginPage = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Check if user is already logged in - redirect if needed
  useEffect(() => {
    if (localStorage.getItem('isAuthenticated') === 'true') {
      window.location.href = '/';
    }
  }, []);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const validUsername = 'data_wizard';
    const validPassword = 'insights$123';
    
    // Simulate API delay
    setTimeout(() => {
      if (credentials.username === validUsername && credentials.password === validPassword) {
        // Set auth status in local storage
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('user', JSON.stringify({
          name: 'Data Wizard',
          role: 'Analytics Master'
        }));
        
        // Navigate to dashboard
        window.location.href = '/';
      } else {
        setError('Invalid username or password');
      }
      setLoading(false);
    }, 800);
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-indigo-200 to-purple-200 py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Abstract data visualization background elements */}
      <div className="absolute inset-0 overflow-hidden opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full"></div>
        <div className="absolute top-[35%] left-[20%] w-80 h-1 bg-white rotate-45"></div>
        <div className="absolute top-[50%] left-[25%] w-96 h-1 bg-white -rotate-12"></div>
        <div className="absolute top-[65%] left-[10%] w-52 h-1 bg-white rotate-45"></div>
        
        <div className="absolute top-[20%] right-[20%] w-60 h-1 bg-white -rotate-45"></div>
        <div className="absolute top-[40%] right-[10%] w-40 h-1 bg-white rotate-12"></div>
        <div className="absolute top-[70%] right-[15%] w-72 h-1 bg-white -rotate-45"></div>
        
        {/* Animated chart dots */}
        {[...Array(12)].map((_, i) => (
          <div 
            key={i}
            className={`absolute w-3 h-3 bg-white rounded-full animate-pulse`}
            style={{ 
              top: `${25 + (i * 4)}%`, 
              left: `${35 + (i * 2.5)}%`,
              animationDelay: `${i * 0.1}s` 
            }}
          ></div>
        ))}
        
        {/* Circular elements - data nodes */}
        {[...Array(15)].map((_, i) => (
          <div 
            key={`circle-${i}`}
            className="absolute w-16 h-16 bg-white rounded-full opacity-20"
            style={{ 
              top: `${Math.random() * 100}%`, 
              left: `${Math.random() * 100}%`,
              transform: `scale(${Math.random() * 0.5 + 0.5})` 
            }}
          ></div>
        ))}
      </div>
      
      <div className="max-w-md w-full space-y-8 bg-white bg-opacity-90 backdrop-blur-sm p-8 rounded-xl shadow-lg relative z-10">
        <div>
          <h1 className="mt-2 text-center text-4xl font-extrabold text-indigo-700">
            Centra<span className='text-fuchsia-500'>360</span>
          </h1>
          {/* <p className="mt-3 text-center text-lg text-indigo-600">
            Simple Insights, Better Decisions
          </p>
          <div className="flex justify-center mt-4">
            <div className="h-1 w-48 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full"></div>
          </div> */}
        </div>
        
        <div className="mt-10">
          <div className="bg-white p-6 rounded-lg">
            <h2 className="text-xl font-bold text-center text-gray-800 mb-8">
              Login to Your Dashboard
            </h2>
            
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <div className="mt-1 relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <svg className="h-6 w-6 text-indigo-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <input
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="username"
                    required
                    value={credentials.username}
                    onChange={handleChange}
                    className="pl-12 block w-full border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-base py-3"
                    placeholder="Username"
                  />
                </div>
              </div>
              
              <div>
                <div className="mt-1 relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <svg className="h-6 w-6 text-indigo-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    value={credentials.password}
                    onChange={handleChange}
                    className="pl-12 block w-full border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-base py-3"
                    placeholder="Password"
                  />
                </div>
              </div>
              
              {error && (
                <div className="rounded-md bg-red-50 p-4">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <h3 className="text-sm font-medium text-red-800">{error}</h3>
                    </div>
                  </div>
                </div>
              )}
              
              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className={`w-full flex justify-center py-4 px-6 border border-transparent rounded-lg shadow-md text-base font-medium text-white ${
                    loading 
                      ? 'bg-indigo-400' 
                      : 'bg-indigo-500 hover:bg-indigo-600'
                  } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200`}
                >
                  {loading ? (
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  ) : (
                    <span>Unlock Insights</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        
        {/* Floating analytics elements */}
        <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-blue-400 bg-opacity-20 rounded-full backdrop-blur-sm"></div>
        <div className="absolute -top-6 -left-6 w-24 h-24 bg-purple-400 bg-opacity-20 rounded-full backdrop-blur-sm"></div>
      </div>
    </div>
  );
};

export default LoginPage;